export enum MenuPointUrl {
	DASHBOARD = '/dashboard',
	REPLAY = '/replay',
	REMOTE = '/remote',
	LOGOUT = '/logout',
	MAP_EDITOR = '/map-editor',
	MAP_EDITOR_EDITOR = '/map-editor/editor',
	MAPS = '/map-editor/maps',
}
